export default{
    typeOfGravidity : 'نوع بارداری',
    ectopicPregnancy : 'حاملگی خارج رحمی(EP)',
    intrauterinePregnancy : 'حاملگی داخل رحمی(IP)',
    abortionInformation : 'اطلاعات سقط ',
    parityInformation : 'اطلاعات زایمان ',
    molarInformation : 'اطلاعات مولار ',
    ipType : 'نوع حاملگی داخل رحمی(IP)',
    LocationOfEctopicPregnancy : 'محل حاملگی خارج رحمی',
    GA : 'G.A(week) ',
    ttc : 'TTC',
    typeOfSurgical : 'نوع جراحی',
    methodOfPregnancy : 'روش بارداری',
    typeOfParity : 'نوع زایمان',
    lch : 'LCH',
    dch : 'DCH',
    parityDate : 'تاریخ زایمان',
    molarDate : 'تاریخ مولار',
    abortionDate : 'تاریخ سقط',
    parity : 'زایمان',
    abortion : 'سقط جنین',
    molar : 'مولار',
    typeOfAbortion :'نوع سقط جنین',
    causeOfAbortion :'دلیل سقط',
    methodOfAbortion :'روش سقط',
}